import { defineStore } from 'pinia';

export const useMapStore = defineStore('map', {
  state: () => ({
    mapIsOpen: false,
    selectedUniversity: null,
  }),

  actions: {
    toggleMap() {
      this.mapIsOpen = !this.mapIsOpen;
    },
    openMap() {
      this.mapIsOpen = true;
    },
    closeMap() {
      this.mapIsOpen = false;
    },
    setSelectedUniversity(university) {
      this.selectedUniversity = university;
    },
  },
});
